import { Injectable } from '@angular/core';
import { AssetTypeService } from './asset-type.service';
import { Outcome } from '../models/outcomes/Outcome';
import { AlertController } from '@ionic/angular';
import { AssetInScene } from '../models/AssetInScene';
import { BaseAsset } from '../models/assets/BaseAsset';
import { TextAsset } from '../models/assets/TextAsset';
import { MediaAsset } from '../models/assets/MediaAsset';
import { Learner } from '../models/Learner';
import { User } from '../models/User';
import { Customer } from '../models/Customer';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {


  public uploadedFileType: string;
  public uploadedFileFormat: string;

  constructor(public assetTypeService: AssetTypeService, public alertController: AlertController) { }

  isEmptyOrNull(value): boolean {
    if (value) {
      for (var i = 0; i < value.length; i++) {
        if (value[i] != ' ') {
          return false;
        }
      }
    }
    return true;
  }

  isOutcomeValid(outcome: Outcome): boolean {

    return (!this.isEmptyOrNull(outcome.title))
      && !this.isEmptyOrNull(outcome.learningOutcomes)
      && !this.isEmptyOrNull(outcome.level)
      && !this.isEmptyOrNull(outcome.assessmentCriteria);
  }

  checkOutcomeVariableLengths(outcome: Outcome): boolean {
    let errors = false;
    if (outcome.title.length > 40) {
      errors = true;
    }
    if (outcome.level.length > 30) {
      errors = true;
    }
    if (outcome.learningOutcomes.length > 500) {
      errors = true;
    }
    if (outcome.assessmentCriteria.length > 300) {
      errors = true;
    }
    if (outcome.unitPurpose != undefined) {
      if (!this.isEmptyOrNull(outcome.assessmentCriteria)) {
        if (outcome.unitPurpose.length > 200) {
          errors = true;
        }
      }
    }


    return errors;
  }

  isMediaAssetValid(asset: MediaAsset): boolean {
    if (asset) {
      if (this.isEmptyOrNull(asset.name)) {
        return false;
      }
      if (!asset.assetTypeId || this.isEmptyOrNull(asset.src)) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  isLearnerValid(learner: Learner): boolean {
    if (learner) {
      if (this.isEmptyOrNull(learner.username)) {
        return false;
      }
      if (this.isEmptyOrNull(learner.firstName)) {
        return false;
      }
      if (this.isEmptyOrNull(learner.lastName)) {
        return false;
      }
      if (this.isEmptyOrNull(learner.email)) {
        return false;
      }
      else {
        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailRegex.test(learner.email)) {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  isUserValid(user: User): boolean {
    if (user) {
      if (this.isEmptyOrNull(user.userName)) {
        return false;
      }
      if (this.isEmptyOrNull(user.email)) {
        return false;
      }
      if (this.isEmptyOrNull(user.role)) {
        return false;
      }
      else {
        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailRegex.test(user.email)) {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  isCustomerValid(customer: Customer): boolean {
    if (customer) {
      if (this.isEmptyOrNull(customer.name)) {
        return false;
      }
      if (this.isEmptyOrNull(customer.domainName)) {
        return false;
      }
      if (this.isEmptyOrNull(customer.licenseType)) {
        return false;
      }
      if (this.isEmptyOrNull(new Date(customer.expiryDate).toDateString())) {
        return false;
      }
      if (this.isEmptyOrNull(customer.dateFormat)) {
        return false;
      }
      if (this.isEmptyOrNull(customer.country)) {
        return false;
      }
      if (this.isEmptyOrNull(customer.blobStorageLocation)) {
        return false;
      }
      if (!this.isEmptyOrNull(new Date(customer.expiryDate).toDateString())) {
        if (!this.checkDate(customer.expiryDate)) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  checkEmail(email): boolean {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(email)) {
      return false;
    }
    return true;
  }

  isAssetAddedThroughSceneValid(asset): boolean {
    if (asset) {
      var assetType = this.assetTypeService.getType(asset.assetTypeId);
      if (this.isEmptyOrNull(asset.name)) {
        return false;
      }
      if (assetType == 'Text' && this.isEmptyOrNull(asset.text)) {
        return false;
      } else if (assetType == 'Model3D' && this.isEmptyOrNull(asset.src)) {
        return false;
      } else if (assetType == 'Invisible' && this.isEmptyOrNull(asset.shape)) {
        return false;
      } else if (assetType == 'Question' && (this.isEmptyOrNull(asset.text) || asset.responses.filter(r => r.isCorrect).length <= 0)) {
        return false;
      } else if (assetType == 'QuestionSet') {
        if (asset.coverPage == true) {
          if (this.isEmptyOrNull(asset.title) || this.isEmptyOrNull(asset.questionSetDescription)) {
            return false;
          }
        }
      } else if (this.isMediaAsset(this.assetTypeService.getType(asset.assetTypeId))) {
        // could maybe validate media assets here to reduce 2 methods into 1.
      }
      return true;
    } else {
      return false;
    }
  }

  isAssetsInAssetAddedThroughSceneValid(assets: BaseAsset[]): boolean {
    var isValid: boolean = true;

    assets.forEach(asset => {
      if (!this.isAssetAddedThroughSceneValid(asset)) {
        isValid = false
      }
    });

    return isValid;
  }

  async alertForMissingAssetProperties(asset) {
    var missingProperties: string[] = [];
    asset != null ? missingProperties = this.createMissingAssetPropertiesList(asset) : missingProperties.push('Details');

    const alert = await this.alertController.create({
      header: 'Media ' + missingProperties + ' Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });

    await alert.present();
  }

  async alertForMissingAssetsInAssetProperties(assets: BaseAsset[]) {
    var missingProperties: string[] = [];
    for (let i: number = 0; i < assets.length; i++) {
      var asset = assets[i];
      var assetType = this.assetTypeService.getType(asset.assetTypeId);
      var missingPropertiesTemp: string[] = [];
      if (!this.isAssetAddedThroughSceneValid(asset)) {
        asset != null ? missingPropertiesTemp = this.createMissingAssetPropertiesList(asset) : missingPropertiesTemp.push('Details');
        missingPropertiesTemp[0] = (assetType == 'Question' ? assetType : 'Media Row') + ' ' + (i + 1) + ' ' + missingPropertiesTemp[0];
        missingProperties.push(...missingPropertiesTemp);
      }
    }

    const alert = await this.alertController.create({
      header: missingProperties + ' Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });

    await alert.present();
  }

  async alertForNoMediaSelected(asset) {
    var assetType = this.assetTypeService.getType(asset.assetTypeId);

    const alert = await this.alertController.create({
      header: 'Please select an existing ' + assetType + " media to add",
      buttons: [{
        text: 'Ok',
      }
      ]
    });

    await alert.present();
  }

  async alertForNoSceneBackgroundSelected() {

    const alert = await this.alertController.create({
      header: 'Please select an existing media background.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });

    await alert.present();
  }

  async alertForMissingOutcomeProperties(outcome: Outcome) {
    var missingProperties: string[] = [];
    outcome != null ? missingProperties = this.createMissingOutcomePropertiesList(outcome) : missingProperties.push('Details');

    const alert = await this.alertController.create({
      header: 'Outcome ' + missingProperties + ' Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  async alertForOutcomePropertiesTooLong(outcome: Outcome) {
    var missingProperties: string[] = [];
    outcome != null ? missingProperties = this.createOutcomePropertiesTooLongList(outcome) : missingProperties.push('Details');

    const alert = await this.alertController.create({
      header: 'Outcome ' + missingProperties + ' too long. Please reduce the size of these properties.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  async alertForLearnerErrors(learner: Learner) {
    var missingProperties: string[] = [];
    learner != null ? missingProperties = this.createLearnerPropertiesMissingList(learner) : missingProperties.push('Error');

    const alert = await this.alertController.create({
      header: 'Learner' + missingProperties + '.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  async alertForUserErrors(user: User) {
    var missingProperties: string[] = [];
    user != null ? missingProperties = this.createUserPropertiesMissingList(user) : missingProperties.push('Error');

    const alert = await this.alertController.create({
      header: 'User' + missingProperties + '.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  async alertForCustomerErrors(customer: Customer) {
    var missingProperties: string[] = [];
    customer != null ? missingProperties = this.createCustomerPropertiesMissingList(customer) : missingProperties.push('Error');

    const alert = await this.alertController.create({
      header: 'Customer' + missingProperties + '.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }


  removeHtmlTags(value: string): string {
    if (value) {
      return value.replace(/</ig, "").replace(/>/ig, "");
    }
    return null;
  }

  checkOutcomeDate(outcomeDate: Date) {
    var dateToCheck = this.convertDate(outcomeDate);
    var todaysDate = this.convertDate(new Date());

    if (dateToCheck < todaysDate) {
      return false;
    }
    else {
      return true;
    }
  }


  convertDate(date: Date) {
    return String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
  }


  createMissingAssetPropertiesList(asset): string[] {
    var missingProperties: string[] = [];

    var assetType = '';
    if (asset.assetTypeId) {
      var assetType = this.assetTypeService.getType(asset.assetTypeId);
    }

    if (this.isEmptyOrNull(asset.name)) {
      missingProperties.push(' Name')
    }
    if (assetType == 'Text' && this.isEmptyOrNull(asset.text)) {
      missingProperties.push(' Text')
    }
    if (assetType == 'Question') {
      if (this.isEmptyOrNull(asset.text)) {
        missingProperties.push(' Question Text')
      }
      if (asset.responses.filter(r => r.isCorrect).length <= 0) {
        missingProperties.push(' Question Correct Answer')
      }
    }
    if (assetType == 'QuestionSet') {
      if (asset.coverPage == true) {
        if (this.isEmptyOrNull(asset.title)) {
          missingProperties.push(' Cover Page Title');
        }
        if (this.isEmptyOrNull(asset.questionSetDescription)) {
          missingProperties.push(' Cover Page Description');
        }
      }
    }
    if (!asset.assetTypeId) {
      missingProperties.push(' File');
    }
    if ((assetType == 'Image' || assetType == 'Video' || assetType == 'Audio' || assetType == 'Model3D') && !asset.src) {
      missingProperties.push(' File');
    }

    if ((assetType == 'Invisible') && !asset.shape) {
      missingProperties.push(' Shape');
    }

    return missingProperties;
  }

  createMissingOutcomePropertiesList(outcome: Outcome): string[] {
    var missingProperties: string[] = [];

    this.isEmptyOrNull(outcome.title) ? missingProperties.push(' Title') : null;
    this.isEmptyOrNull(outcome.level) ? missingProperties.push(' Level') : null;
    this.isEmptyOrNull(outcome.learningOutcomes) ? missingProperties.push(' Learning Outcomes') : null;
    this.isEmptyOrNull(outcome.assessmentCriteria) ? missingProperties.push(' Assessment Criteria') : null;
    return missingProperties;
  }

  createOutcomePropertiesTooLongList(outcome: Outcome): string[] {
    var missingProperties: string[] = [];

    outcome.title.length > 40 ? missingProperties.push(' Title') : null;
    outcome.level.length > 30 ? missingProperties.push(' Level') : null;
    outcome.learningOutcomes.length > 500 ? missingProperties.push(' Learning Outcomes') : null;
    outcome.assessmentCriteria.length > 300 ? missingProperties.push(' Assessment Criteria') : null;
    if (outcome.unitPurpose != undefined) {
      if (!this.isEmptyOrNull(outcome.assessmentCriteria)) {
        outcome.unitPurpose.length > 200 ? missingProperties.push(' Unit Purpose') : null;
      }
    }
    return missingProperties;
  }

  createLearnerPropertiesMissingList(learner: Learner): string[] {
    var missingProperties: string[] = [];

    this.isEmptyOrNull(learner.username) ? missingProperties.push(' Username') : null;
    this.isEmptyOrNull(learner.firstName) ? missingProperties.push(' First name') : null;
    this.isEmptyOrNull(learner.lastName) ? missingProperties.push(' Last name') : null;
    this.isEmptyOrNull(learner.email) ? missingProperties.push(' email') : null;
    if (missingProperties.length != 0) {
      missingProperties.push(' Required');
    }

    if (!this.isEmptyOrNull(learner.email)) {
      if (!this.checkEmail(learner.email)) {
        missingProperties.push(' email invalid');
      }
    }
    return missingProperties;
  }

  createUserPropertiesMissingList(user: User): string[] {
    var missingProperties: string[] = [];

    this.isEmptyOrNull(user.userName) ? missingProperties.push(' name') : null;
    this.isEmptyOrNull(user.email) ? missingProperties.push(' email') : null;
    this.isEmptyOrNull(user.role) ? missingProperties.push(' role') : null;
    if (missingProperties.length != 0) {
      missingProperties.push(' Required');
    }

    if (!this.isEmptyOrNull(user.email)) {
      if (!this.checkEmail(user.email)) {
        missingProperties.push(' email invalid');
      }
    }
    return missingProperties;
  }

  createCustomerPropertiesMissingList(customer: Customer): string[] {
    var missingProperties: string[] = [];

    this.isEmptyOrNull(customer.name) ? missingProperties.push(' name') : null;
    this.isEmptyOrNull(customer.domainName) ? missingProperties.push(' domain name') : null;
    this.isEmptyOrNull(customer.licenseType) ? missingProperties.push(' license') : null;
    this.isEmptyOrNull(customer.country) ? missingProperties.push(' country') : null;
    this.isEmptyOrNull(customer.dateFormat) ? missingProperties.push(' date format') : null;
    this.isEmptyOrNull(customer.blobStorageLocation) ? missingProperties.push(' blob storage location') : null;
    this.isEmptyOrNull(new Date(customer.expiryDate).toDateString()) ? missingProperties.push(' expiry date') : null;
    if (missingProperties.length != 0) {
      missingProperties.push(' Required');
    }

    if (!this.isEmptyOrNull(new Date(customer.expiryDate).toDateString())) {
      if (!this.checkDate(customer.expiryDate)) {
        missingProperties.push(' expiry date invalid');
      }
    }
    return missingProperties;
  }

  checkDate(date: Date): boolean {
    var today = new Date();
    var expiryDate = new Date(date);
    today.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);
    if (expiryDate < today) {
      return false;
    }
    else {
      return true;
    }
  }


  doesUploadedFileMatchAssetType(assetTypeId): boolean {
    var assetType = this.assetTypeService.getType(assetTypeId);

    if (this.isMediaAsset(assetType) && assetType != this.uploadedFileType) {
      return false;
    }
    return true;
  }

  checkFileEndsWith(fileFormat): boolean {
    return this.uploadedFileFormat.toLowerCase().endsWith(fileFormat);
  }

  async createAlert(message: string) {
    const alert = await this.alertController.create({
      header: message,
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }


  isFileFormatCorrect(assetTypeId): boolean {
    var assetType = this.assetTypeService.getType(assetTypeId);

    switch (assetType) {
      case 'Image': {
        if (this.checkFileEndsWith('/png') || this.checkFileEndsWith('/jpeg') || this.checkFileEndsWith('/gif')) {
          return true;
        }
        break;
      }
      case 'Video': {
        if (this.checkFileEndsWith('/mp4') || this.checkFileEndsWith('/quicktime')) {
          return true;
        }
        break;
      }
      case 'Audio': {
        if (this.checkFileEndsWith('/mp3') || this.checkFileEndsWith('/mpeg') || this.checkFileEndsWith('/ogg') || this.checkFileEndsWith('/wav')) {
          return true;
        }
        break;
      }
      case 'Model3D': {
        if (this.checkFileEndsWith('/glb')) {
          return true;
        }
        break;
      }
      default: {
        break;
      }
    }
    return false;

  }

  isMediaAsset(assetType) {
    if (assetType == 'Image' || assetType == 'Video' || assetType == 'Audio' || assetType == 'Model3D') {
      return true;
    }
    return false;
  }

  isMediaAssetById(assetTypeId) {
    if (assetTypeId == 4 || assetTypeId == 5 || assetTypeId == 6 || assetTypeId == 9) {
      return true;
    }
    return false;
  }

  setFileType(event) {
    this.uploadedFileFormat = event.target.files[0].type;

    if (this.uploadedFileFormat.startsWith('image')) this.setUploadFileType('Image');
    else if (this.uploadedFileFormat.startsWith('audio') || this.uploadedFileFormat.endsWith('ogg')) this.setUploadFileType('Audio');
    else if (this.uploadedFileFormat.startsWith('video')) this.setUploadFileType('Video');

    if (event.target.files[0].name) {
      var fileNameArray: string[] = event.target.files[0].name.split('.');
      if (fileNameArray[fileNameArray.length - 1] == 'glb') {
        this.setUploadFileType('Model3D');
        this.uploadedFileFormat = '/glb';
      }
    }
  }

  setUploadFileType(fileType: string) {
    this.uploadedFileType = fileType;
  }

  validateMaxValue(value: number, maxValue: number): number {
    return value > maxValue ? maxValue : value;
  }

  validateMinValue(value: number, minValue: number): number {
    return value < minValue ? minValue : value;
  }

  validateEmail(email: string): boolean {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  }

  removeExcessLineBreaks(text: string): string{
    let textSplit: string[] = text.split(/\r\n|\r|\n/);
    let newText: string = "";
    let lineBreak = "";
    if(textSplit.length > 3){ 
      for(let i: number = 0; i < textSplit.length; i++){
        let line = textSplit[i];
        if(i < 3){
          newText = newText + lineBreak + line;
        }else{
          newText = newText + " " + line;
        }
        lineBreak = "\n";
      }

      return newText;
    }

    return text;
  }

}
